<script setup>
// (i) "Como contamos" de toda tela de relatório que recorta por algo que muda
// depois do fato (time, etiqueta, responsável, "sem resposta"). Cada número usa
// o valor de ALGUM momento — exemplos, não lista: o agregado guarda o de quando
// a hora fechou (Reports::HourlyCounts/HourlyEvents/HourlyCsatSent), a fonte
// (pontas, horas recalculadas, sem histórico, fuso, backfill) usa o de agora,
// e a avaliação do CSAT carimba o agente do momento da resposta.
//
// UM texto pra todas as telas, e ele NÃO enumera casos NEM momentos: as 5
// rodadas de review que acharam nota prometendo mais do que o código entrega
// acharam listas fechadas (de exceções e, na rodada 4, de momentos). Caminho
// novo que sai da fonte não exige mexer aqui; tela nova com dimensão-retrato
// só precisa usar o componente.
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <!-- button: o tooltip abre por foco (teclado) e toque, não só hover. -->
  <button
    v-tooltip.bottom="t('REPORT.HOW_WE_COUNT_NOTE')"
    type="button"
    class="inline-flex w-fit items-center gap-1 text-xs text-n-slate-11 hover:text-n-slate-12"
  >
    <span class="i-lucide-info size-3.5" />
    {{ t('REPORT.HOW_WE_COUNT') }}
  </button>
</template>
